export const GetQRResourcesBS: GetQRResourcesInterface = {
  title: "Naziv tacke primjene",
  subtitle: "Planirani zadaci",
  buttons: {
    popuni: "Popuni",
    pregled: "Pregled",
    primjedbe: "Primjedbe",
  },
  errors: {
    noinput:
      "Potrebna polja nisu unesena. Molimo kontaktirajte administratora.",
    errorQuery:
      "Doslo je do greske tokom prikupljanja podataka. Molimo kontaktirajte administratora.",
    recordPointNotFound: {
      title: "Tačka evidencije nije pronađena",
      message: "Tražena tačka evidencije nije pronađena u sistemu.",
      suggestion: "Molimo kontaktirajte administratora za pomoć.",
      icon: "mdi mdi-alert-circle-outline",
    },
    privateAccess: {
      title: "Privatna tačka evidencije",
      message:
        "Ova tačka evidencije je privatna i dostupna je samo autorizovanim korisnicima. Za pristup ovim podacima potrebna je prijava u sistem.",
      suggestion:
        "Molimo kontaktirajte administratora za pristup ili se prijavite u sistem.",
      icon: "mdi mdi-lock-outline",
      mobileMessage:
        "Ova tačka evidencije je privatna. Potrebna je prijava za pristup.",
      mobileSuggestion: "Kontaktirajte administratora za pristup.",
    },
  },
  noItems: {
    title: "Nema dostupnih evidencija",
    message:
      "Za odabrani period i kriterije nema dostupnih evidencija za pregled.",
    suggestion:
      "Molimo provjerite datumski raspon ili kontaktirajte administratora.",
  },
  noActiveRecords: {
    title: "Nema aktivnih evidencija",
    message:
      "Za skeniranu tačku primjene nema aktivnih evidencija koje treba da se popune.",
    suggestion:
      "Evidencija je već popunjena za odabrani period. Molimo provjerite datumski raspon ili kontaktirajte administratora.",
  },
  noRecordPoints: {
    message:
      "Trenutno nema tačaka evidencije za odabrani period. Molimo odaberite drugačiji datumski period.",
  },
  inputFields: {
    endDate: {
      label: "Krajnji datum",
    },
    startDate: {
      label: "Pocetni datum",
    },
  },
  poljaEvidencije: {
    CIPP_V1: "Ciscenje i pranje prostora",
    CIPO_V1: "Ciscenje i pranje opreme",
    Dezinfekcija_V1: "Dezinfekcija",
    Dezinsekcija_V1: "Dezinsekcija",
    Deratizacija_V1: "Deratizacija",
    Dezinsekcija_Kontrola_V1: "Dezinsekcija Kontrola",
    Dezinskecija_Korekcija_V1: "Dezinsekcija Korekcija",
    Deratizacija_Kontrole_V1: "Deratizacija Kontrole",
    Deratizacija_Korekcije_V1: "Deratizacija Korekcije",
    DezSr_V1: "Sredstava za dezinfekciju",
    Dobavljac_V1: "Dobavljaci",
    Dostava_V1: "Dostava",
    EduZap_V1: "Edukacija zaposlenih",
    Mol_V1: "Molerski radovi",
    Oprema_V1: "Oprema",
    Otpad_V1: "Otpad",
    PrijemRobe_V1: "Prijem robe",
    San_V1: "Sanitarni pregled",
    Temperatura_V1: "Temperaturne liste",
    TemperaturaOgranicena_V1: "Temperaturne liste - ogranicena",
    TemperaturaOgranicenaKKT_V1: "Temperaturne liste - ogranicena - KKT",
    TemperaturaKKTProizvodiEvd_V1: "Temperaturne liste - proizvodi - KKT",
    CheckListEvd_V1: "Checklista",
  },
};

export interface GetQRResourcesInterface {
  title: string;
  subtitle: string;
  buttons: {
    popuni: string;
    pregled: string;
    primjedbe: string;
  };
  errors: {
    noinput: string;
    errorQuery: string;
    recordPointNotFound: {
      title: string;
      message: string;
      suggestion: string;
      icon: string;
    };
    privateAccess: {
      title: string;
      message: string;
      suggestion: string;
      icon: string;
      mobileMessage: string;
      mobileSuggestion: string;
    };
  };
  noItems: {
    title: string;
    message: string;
    suggestion: string;
  };
  noActiveRecords: {
    title: string;
    message: string;
    suggestion: string;
  };
  noRecordPoints: {
    message: string;
  };
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
  };
  poljaEvidencije: {
    CIPP_V1: string;
    CIPO_V1: string;
    Dezinfekcija_V1: string;
    Dezinsekcija_V1: string;
    Deratizacija_V1: string;
    Dezinsekcija_Kontrola_V1: string;
    Dezinskecija_Korekcija_V1: string;
    Deratizacija_Kontrole_V1: string;
    Deratizacija_Korekcije_V1: string;
    DezSr_V1: string;
    Dobavljac_V1: string;
    Dostava_V1: string;
    EduZap_V1: string;
    Mol_V1: string;
    Oprema_V1: string;
    Otpad_V1: string;
    PrijemRobe_V1: string;
    San_V1: string;
    Temperatura_V1: string;
    TemperaturaOgranicena_V1: string;
    TemperaturaOgranicenaKKT_V1: string;
    TemperaturaKKTProizvodiEvd_V1: string;
    CheckListEvd_V1: string;
  };
}

// http://localhost:3000/getqr?rtc=58&name=Dvoriste
